import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_loaikhoan, Lists_tinhchatnguonkp, Lists_tieumuc } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-dm-loaitaisanedit',
  templateUrl: './loaitaisanedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./loaitaisanedit.component.scss'],
    providers: [ListService, Repository]
})


export class loaitaisaneditComponent implements OnInit {

   
    
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
    inputparents: any
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, Ma_Doi_Tuong: null, TK_Khau_Hao_Id: null, TK_Tai_San_Id: null, Loai_Khoan_Id: null, Thoi_Gian_Khau_Hao: null, Tieu_Muc_Id: null, Tu_Chu: null, Ten_Doi_Tuong: null, Ghi_Chu: null, Parent: null, Trang_Thai: null, Nhom_Doi_Tuong_ID: null, Don_Vi_Id: null, Ma_Ao: null
    , TK_Tai_San_24_Id: null, TK_No_HM_24: null, TK_Co_HM_24: null
  };    
    nhomdtid:string=null;
  hoatdong: string = null;
  inputloaikhoans: any;
  inputtieumucs: any;
  inputtaikhoantaisans: any;
  inputtaikhoantaisan24s: any;

  @ViewChild('slLoaiKhoan', { static: false }) slLoaiKhoan: NgSelectComponent;
  @ViewChild('slTieuMuc', { static: false }) slTieuMuc: NgSelectComponent;
  @ViewChild('slTaiKhoanTaiSan', { static: false }) slTaiKhoanTaiSan: NgSelectComponent;
  @ViewChild('slTaiKhoanHaoMon', { static: false }) slTaiKhoanHaoMon: NgSelectComponent;
  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
    @Output() save: EventEmitter<any> = new EventEmitter();
  
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };


    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;

  loadDataInit(nhomdoituongid: string, id: string, donviid: string) {

    this.repo.postRequest('api/taikhoan/dstaikhoanv2', { NamKeToan: 2024, DonViId: donviid, UserName: null })
      .subscribe(response => { this.inputtaikhoantaisans = response; });

    this.repo.postRequest('api/taikhoan/dstaikhoanv2', { NamKeToan: 2025, DonViId: donviid, UserName: null })
      .subscribe(response => { this.inputtaikhoantaisan24s = response; });

    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_loaikhoan.id, MaGiaoDien: '', DonViId: donviid})
      .subscribe(response => {
        this.inputloaikhoans = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_tieumuc.id, MaGiaoDien: '', DonViId: donviid })
      .subscribe(response => {
        this.inputtieumucs = response;
      });


    if (nhomdoituongid.toLocaleLowerCase() === Lists_tinhchatnguonkp.id.toLocaleLowerCase())
      this.bnguonkinhphi = true;   
      this.hoatdong = "Hoạt động"

          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            let data = JSON.parse(authlogin);
            var giatri = data.ds_quyen.filter(name => name.id === nhomdoituongid.toLowerCase());
            if (giatri != null && giatri.length > 0) {
              if (giatri[0].them == true)
                this.quyen_them = true;
              else
                this.quyen_them = false;
              if (giatri[0].sua == true)
                this.quyen_sua = true;
              else
                this.quyen_sua = false;
              if (giatri[0].xoa == true)
                this.quyen_xoa = true;
              else
                this.quyen_xoa = false;
            }
          }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
    }, 500);
    this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/' + (id != null ? id:'null') + '/' + donviid)
        .subscribe(response => {            
            this.inputparents=response;
        });
    this.doituongSelect = { Id: null, Ma_Doi_Tuong: null, Tu_Chu: null, Ten_Doi_Tuong: null, Ghi_Chu: null, Parent: null, Trang_Thai: true, Nhom_Doi_Tuong_ID: nhomdoituongid, Don_Vi_Id: donviid, Ma_Ao: null, Loai_Khoan_Id: null, Thoi_Gian_Khau_Hao: null, Tieu_Muc_Id: null};   
        
        if(id === null)
        {
            console.log("vao loaddatainit" + id);
            this.repo.getRequest("api/doituong/SinhMaDoiTuong/" + nhomdoituongid + '/'+donviid)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Ma_Doi_Tuong = response;
            });
          this.doituongSelect.Trang_Thai = true;
          this.doituongSelect.Tu_Chu = false;
        }
        else {
          console.log("t11");
          this.repo.getRequest("api/doituongtaisan/getmodel/" + id)
            .subscribe(response => {  
                console.log(response);
              this.doituongSelect.Id = id;
              this.doituongSelect.Tu_Chu = response.Tu_Chu;
                this.doituongSelect.Ma_Doi_Tuong = response.Ma_Doi_Tuong;
                this.doituongSelect.Ten_Doi_Tuong = response.Ten_Doi_Tuong;
                this.doituongSelect.Trang_Thai = response.Trang_Thai;
                this.doituongSelect.Ghi_Chu = response.Ghi_Chu;
                this.doituongSelect.Parent = response.Parent;
              this.doituongSelect.Ma_Ao = response.Ma_Ao;
              this.doituongSelect.Loai_Khoan_Id = response.Loai_Khoan_Id;
              this.doituongSelect.Thoi_Gian_Khau_Hao = response.Thoi_Gian_Khau_Hao;
              this.doituongSelect.Tieu_Muc_Id = response.Tieu_Muc_Id;
              this.doituongSelect.TK_Tai_San_Id = response.TK_Tai_San_Id;
              this.doituongSelect.TK_Khau_Hao_Id = response.TK_Khau_Hao_Id;

              this.doituongSelect.TK_Tai_San_24_Id = response.TK_Tai_San_24_Id;
              this.doituongSelect.TK_No_HM_24 = response.TK_No_HM_24;
              this.doituongSelect.TK_Co_HM_24 = response.TK_Co_HM_24;


            }); 
        }
        
       
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
          this.slLoaiKhoan.focus();
            event.preventDefault();
          }
  }
  keyLoaiKhoanPress(event: any) {
    if (event.which === 13) {
      this.slTieuMuc.focus();
      event.preventDefault();
    }
  }
  keyTKNguyenGiaPress(event: any) {
    if (event.which === 13) {
      this.slTaiKhoanHaoMon.focus();
      event.preventDefault();
    }
  }
  keyTKHaoMonPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  keyThoiGianPress(event: any) {
    if (event.which === 13) {
      this.slTaiKhoanTaiSan.focus();
      event.preventDefault();
    }
  }
    public closeModal(){
        this.save.emit(null);
    }
    public saveproduct() {
        if (this.doituongSelect.Ten_Doi_Tuong == null || this.doituongSelect.Ten_Doi_Tuong == "") {
            swal('Lỗi!', 'Vui lòng nhập tên đối tượng!.', 'error');
            return;
      }
      console.log(this.doituongSelect);
      this.repo.postRequest("api/doituongtaisan/addorupdate",this.doituongSelect)
            .subscribe(response => {  
                
              if (response != null && response.match('-')) {
                this.doituongSelect.Id = response;
                this.save.emit(this.doituongSelect);
              }
              else {
                swal('Lỗi!', response, 'error');
              }
            }); 
    }
   
    
   

   


}
